export enum TourEnum {
  SKIPPED = "skipped",
  FINISHED = "finished"
}
